import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import OrganizationsListPage from "./organization/OrganizationsListPage";
import UsersListPage from "./user/UserListPage.jsx";
import Loading from "../layout/Loading.jsx";

import useTriggeredAPICall from "../../hooks/fetch-hooks/useTriggeredAPICall";

export default function UniversalSearch({ searchTerm, ...props }) {
  const [searchResults, setSearchResults] = useState({
    organizations: [],
    users: [],
  });

  const { fetchData, data, isLoading } = useTriggeredAPICall();

  const renderOrganizations = () => {
    if (searchResults.organizations.length) {
      return (
        <OrganizationsListPage
          columns={[
            { id: "name", width: "250x" },
            { id: "city", width: "150px" },
            { id: "state", width: "100px" },
            { id: "is_active", width: "80px" },
          ]}
          hideSearch={true}
          orgList={searchResults.organizations}
        />
      );
    }
    return false;
  };

  const renderUsers = () => {
    if (searchResults.users.length) {
      return (
        <UsersListPage
          hideSearch={true}
          columns={[
            { id: "first_name", width: "105px" },
            {
              id: "email",
              width: "175px",
              cell: (row) => (
                <div className="text-primary truncate">
                  {!row?.email ? "-" : row.email}
                </div>
              ),
            },
            { id: "phone", width: "112px" },
            {
              id: "orgName",
              width: "70px",
              cell: (row) => (
                <div
                  className="cursor-pointer text-primary truncate"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCellClick(row);
                  }}
                >
                  {!row?.organization?.name ? (
                    "-"
                  ) : (
                    <Link
                      className="table-link truncate"
                      to={`/organization/${row.org_id}`}
                    >
                      {row.organization.name}
                    </Link>
                  )}
                </div>
              ),
            },
            {
              id: "companyName",
              width: "70px",
              cell: (row) => (
                <div
                  className="cursor-pointer text-primary truncate"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCellClick(row);
                  }}
                >
                  {!row?.companies || row?.companies?.length === 0 ? (
                    "-"
                  ) : (
                    <Link
                      className="table-link truncate"
                      to={`/company/${row.org_id}`}
                    >
                      {row.companies[0].name}
                    </Link>
                  )}
                </div>
              ),
            },
            { id: "role", width: "63px" },
            { id: "is_active", width: "63px" },
          ]}
          userList={searchResults.users}
        />
      );
    }
    return false;
  };

  useEffect(() => {
    if (searchTerm) {
      fetchData(`/search?q=${searchTerm}`, "GET").then((result) => {
        setSearchResults({
          organizations: result.organizations,
          users: result.users,
        });
      });
    } else {
      setSearchResults({
        organizations: [],
        users: [],
      });
    }
  }, [searchTerm, fetchData]);

  if (isLoading) {
    return <Loading />;
  }

  const hasResults =
    searchResults.organizations.length > 0 || searchResults.users.length > 0;

  return (
    <div className="width-full">
      <button className="search-title" onClick={() => props.history.goBack()}>
        <FontAwesomeIcon icon={faChevronLeft} /> Back
      </button>

      <h1 className="search-title">Search Results</h1>

      {hasResults ? (
        <>
          <div className="organizations">{renderOrganizations()}</div>
          <div className="users">{renderUsers()}</div>
        </>
      ) : (
        <p className="flex-column">There are no records to display</p>
      )}
    </div>
  );
}
